export const INDUSTRIES = [
  {
    slug: "b2b-saas-and-tech",
    name: "B2B SaaS and tech",
    headline: "More pipeline, less manual prospecting.",
    workflows: [
      {
        title: "Outbound engine for one market",
        steps: ["Target list built", "Sequences sending", "Replies handled", "Meeting booked"],
      },
      {
        title: "Inbound demo request reply and routing",
        steps: ["Demo request", "Instant reply", "Scored and routed", "Owner notified"],
      },
      {
        title: "CRM hygiene and pipeline reports",
        steps: ["Deals checked", "Fields completed", "Reminders sent", "Weekly report"],
      },
    ],
  },
  {
    slug: "clinics-and-aesthetic-practices",
    name: "Clinics and aesthetic practices",
    headline: "Reply to every enquiry in a minute, even after hours.",
    workflows: [
      {
        title: "Instant WhatsApp reply and booking",
        steps: ["Enquiry on WhatsApp", "Instant reply", "Questions answered", "Appointment booked"],
      },
      {
        title: "Appointment reminders and no-show recovery",
        steps: ["Appointment booked", "Reminder sent", "No-show spotted", "Rebooking offered"],
      },
      {
        title: "Win back past patients",
        steps: ["Past patients listed", "Message sent", "Reply handled", "Visit booked"],
      },
    ],
  },
  {
    slug: "education-and-tuition-centres",
    name: "Education and tuition centres",
    headline: "Turn trial class enquiries into enrolments.",
    workflows: [
      {
        title: "Instant reply to parent enquiries",
        steps: ["Parent enquires", "Instant reply", "Questions answered", "Details captured"],
      },
      {
        title: "Trial class booking and reminders",
        steps: ["Trial offered", "Slot booked", "Reminder sent", "Attendance logged"],
      },
      {
        title: "Follow-up after the trial",
        steps: ["Trial finished", "Follow-up sent", "Questions answered", "Enrolment closed"],
      },
    ],
  },
  {
    slug: "fitness-studios",
    name: "Fitness studios",
    headline: "Fill classes without chasing every lead by hand.",
    workflows: [
      {
        title: "Instant reply to ad leads",
        steps: ["Ad lead arrives", "Instant reply", "Interest confirmed", "Details captured"],
      },
      {
        title: "Trial booking",
        steps: ["Trial offered", "Class booked", "Reminder sent", "Attendance logged"],
      },
      {
        title: "Follow-up for members who stop coming",
        steps: ["Drop-off spotted", "Check-in message", "Reply handled", "Class booked"],
      },
    ],
  },
];

export const getIndustry = (slug) => INDUSTRIES.find((i) => i.slug === slug);
